import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import {
  CmsConfig,
  FeaturesConfigModule,
  I18nModule,
  OccConfig,
  ProductPageMetaResolver,
  UrlModule,
  provideConfig,
} from '@spartacus/core';
import {
  AtMessageModule,
  CarouselModule,
  IconModule,
  ItemCounterModule,
  ListNavigationModule,
  MediaModule,
  OutletModule,
  PageComponentModule,
  PageSlotModule,
  ProductListModule,
  SpinnerModule,
  StarRatingModule,
} from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { KbAddToCartModule } from '../kb-add-to-cart/kb-add-to-cart.module';
import { compareCheckBoxModule } from '../kb-product-list/check-box-compare/compareCheckBox.module';
import { KbDocumentGridItemModule } from '../kb-product-list/kb-document-grid/kb-document-grid.module';
import { KbDocumentListItemModule } from '../kb-product-list/kb-document-list/kb-document-list.module';
import { KbProductGridItemModule } from '../kb-product-list/kb-product-grid-item/kb-product-grid-item.module';
import { KbProductListItemModule } from '../kb-product-list/kb-product-list-item/kb-product-list-item.module';
import { KbProductListModule } from '../kb-product-list/kb-product-list/kb-product-list.module';
import { KbProductCarouselComponent } from './kb-product-carousel/kb-product-carousel.component';
import { KbProductDetailsComponent } from './kb-product-details/kb-product-details.component';
import { KbProductImageZoomModule } from './kb-product-image-zoom/kb-product-image-zoom.module';
import { DocumentsTabComponent } from './kb-product-tabs/documents-tab/documents-tab.component';
import { GeneralInfoTabComponent } from './kb-product-tabs/general-info-tab/general-info-tab.component';
import { HasServiceSolutionTabComponent } from './kb-product-tabs/has-service-solution-tab/has-service-solution-tab.component';
import { IsServiceSolutionTabComponent } from './kb-product-tabs/is-service-solution-tab/is-service-solution-tab.component';
import { KbProductTabsComponent } from './kb-product-tabs/kb-product-tabs.component';
import { PdpTabGridItemComponent } from './kb-product-tabs/pdp-tab-grid-item/pdp-tab-grid-item.component';
import { PdpTabListItemComponent } from './kb-product-tabs/pdp-tab-list-item/pdp-tab-list-item.component';
import { ServiceToolTabComponent } from './kb-product-tabs/service-tool-tab/service-tool-tab.component';
import { TechnicalAttributesTabComponent } from './kb-product-tabs/technical-attributes-tab/technical-attributes-tab.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { ClosetEquiventTabComponent } from './kb-product-tabs/closet-equivent-tab/closet-equivent-tab.component';
import { KbProductPageMetaResolver } from './kb-product-page-meta.resolver';
export const defaultKbOccProductConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        product: {
          details: 'products/${productCode}?fields=FULL',
        },
      },
    },
    loadingScopes: {
      product: {
        details: {
          include:[]
        },
      },
    },
  },
};
@NgModule({
  declarations: [
    KbProductDetailsComponent,
    KbProductTabsComponent,
    KbProductCarouselComponent,
    GeneralInfoTabComponent,
    TechnicalAttributesTabComponent,
    DocumentsTabComponent,
    IsServiceSolutionTabComponent,
    PdpTabListItemComponent,
    PdpTabGridItemComponent,
    HasServiceSolutionTabComponent,
    ServiceToolTabComponent,
    ClosetEquiventTabComponent,
  ],
  imports: [
    PageSlotModule,
    AtMessageModule,
    CommonModule,
    FeaturesConfigModule,
    I18nModule,
    IconModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    CarouselModule,
    MatTabsModule,
    compareCheckBoxModule,
    KbAddToCartModule,
    SlickCarouselModule,
    ProductListModule,
    KbProductListModule,
    KbProductGridItemModule,
    KbProductListItemModule,
    KbDocumentGridItemModule,
    KbDocumentListItemModule,
    KbProductImageZoomModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        KBProductSummaryFlexComponent: {
          component: KbProductDetailsComponent,
          guards: [SecureGuard],
        },
        CMSTabParagraphContainer: {
          component: KbProductTabsComponent,
          guards: [SecureGuard],
        },
      },
    }),
    {
      provide: ProductPageMetaResolver,
      useExisting: KbProductPageMetaResolver,
    },
    provideConfig(defaultKbOccProductConfig)
  ],
})
export class KbProductDetailsModule {}

